// extracted by mini-css-extract-plugin
export default {"container":"_1mwg6y-k","image":"brui4K1H","desktopImage":"_1CLpyt4n","mobileImage":"_3XH3Zk32"};